import { createApp, computed } from 'vue';
import GoogleSignInPlugin from 'vue3-google-signin';
import App from './App.vue';
import ActiveColorComponent from './utils/activeColor';
import router from './router';
import i18n from './i18n';
import store from './store';
import Emoji from '@/components/emoji';
import { createGtm } from '@gtm-support/vue-gtm';
import './utils/moment';

// Import the library CSS
import '@sliday/karma-ui-library/style.css';

const primaryColor = computed(() => {
  if (store.state.auth && store.state.auth.settings && store.state.auth.settings.active_color)
    return `#${store.state.auth.settings.active_color}`;
  return '#F2AE43';
});

const app = createApp(App);
(async () => {
  await store.dispatch('auth/init');
  app
    .use(GoogleSignInPlugin, {
      clientId: process.env.VUE_APP_GOOGLE_APP_ID,
    })
    .use(
      createGtm({
        id: 'GTM-P8XKS8QV',
        enabled: true,
      }),
    )
    .use(store)
    .use(ActiveColorComponent)
    .use(router)
    .use(i18n)
    .use(Emoji);
  app.provide('primaryColor', primaryColor).mount('#app');
})();

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`);
  });
}
